export const ERRCODE_SUCCESS = 0

export enum ERRCODES_VERSIONCHECK {
  NEED_UPDATE = 10000,
}

export enum ERRCODES_OTPCERTREQUEST {
  ERROR_PHONENUMBER = 10040,
  ERROR_ALREADY_MEMBER = 10041,
  BLOCKED_USERS = 10042,
  ERROR_TELECOM = 10043,
  ERROR_30DAYS_LIMIT = 10044,
  ERROR_YEAR_RE_ENTRY_LIMIT = 10045,
  ERROR_AUTH_MSG_TIME = 10046,
  ERROR_IS_NOT_OPEN_TELECOM = 10047,
  ERROR_AGE80_LIMIT = 200008,
}

export enum ERRCODES_OTPCERTSUBMIT {
  ERROR_EXPIRED_TIME = 10050,
  ERROR_WRONG_APPROVAL_NUMBER = 10051,
  ERROR_EXPIRATION_APPROVAL_NUMBER = 10052,
  ERROR_TELECOM = 10070,
}

export enum ERRCODES_WALLETCOUPON {
  ERROR_NOT_HAS_COUPON = 10200,
}

export enum ERRCODES_COMMON {
  SYSTEMS_ERROR = 9000,
  SESSION_ERROR = 9999,
  AUTH_ERROR = 9998,
  PIN_CHECK_ERROR = 9997,
  ERROR_LOGOUT = 9996,
  SERVER_INTERNAL_ERROR = -1,
  SYSTEM_MAINTENANCE = 9002,
}

export enum ERRCODES_PURCHASE_VALID_CHECK {
  ERROR_NOT_VALID_COUPON = 10440,
  ERROR_HOT_DEAL_SOLD_OUT = 10441,
  ERROR_ONLY_ONE_HOTDEAL_PURCHASE = 10442,
  ERROR_DAILY_PURCHASED = 1001,
  ERROR_DIFFERENT_PRICE = 1002,
  ERROR_MAX_OF_MONTH_HOTDEAL_PURCHASE = 1003,
}
export enum ERRCODES_PURCHASE_CANCEL {
  ERROR_ALREADY_USE = 10451,
  ERROR_CANCEL_PERIOD_OVER = 10452,
  ERROR_CANCEL_ERROR = 10453,
}

export enum ERRCODES_PURCHASE_REFUND {
  ERROR_NAME_MISMATCH = 10460,
}

export enum ERRCODES_GIFT_VALID_CHECK {
  ERROR_LESS_THAN_7DAYS_EXPIRE = 20120,
  ERROR_ALREADY_GIFTED = 20121,
  ERROR_RECEIVE_AFTER_7DAYS = 20180,
  ERROR_GIFT_URL_AUTH = 20140,
}

export enum ERRCODES_PASS_CERT {
  ERROR_CERT_FAILED = 2000,
  ERROR_AUTH_FAILED = 10902,
}
